import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';

const SPKEducationCard = ({
  education,
}: {
  education: GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateEducation'][number];
}) => {
  return (
    <div className="text-sm">
      <p className="font-semibold mb-2 flex items-center">
        <i className="pi pi-building-columns mr-2 text-base" />
        {education.DegreeName}
      </p>
      <p className="text-black/50 ml-4 flex items-center">
        <i className="pi pi-graduation-cap mr-2 text-base" />
        {education.EducationalInstitutionName}
      </p>
    </div>
  );
};

export default SPKEducationCard;
